const firebaseConfig = {
  apiKey: "AIzaSyAOC9yLboiLbSwVenFndtnPxBTJScmHR1s",
  authDomain: "video-app-e5282.firebaseapp.com",
  projectId: "video-app-e5282",
  storageBucket: "video-app-e5282.appspot.com",
  messagingSenderId: "31942636621",
  appId: "1:31942636621:web:c78de4a829365279465804"
};

export default firebaseConfig;